/* 🤖 this file was generated by svg-to-ts*/
export const icoUserFilled: {
  name: 'user-filled';
  data: string;
} = {
  name: 'user-filled',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.332 13c1.97 0 3.561 1.603 3.662 3.598l.005.201.001 1.424-.315.296C18.317 20.745 15.252 22 12 22c-3.127 0-6.081-1.16-8.408-3.228l-.277-.252L3 18.223l.001-1.423c0-2.02 1.527-3.69 3.47-3.795L6.668 13h10.665zM12 3a4 4 0 110 8 4 4 0 010-8z" fill="#909090"/></svg>`
};
